import api from '../../utils/api';
import { ProductPartnerResponse } from '../../models/MasterAdmin/productPartner';
import { ProductOrdersResponse } from '../../models/MasterAdmin/productOrder';

export const fetchProductPartnerProfile = async (vendorId: string): Promise<ProductPartnerResponse> => {
  try {
    const response = await api.get(`/master-admin/getProductPartnerByVendorId/${vendorId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product partner profile:', error);
    throw error;
  }
};

export const fetchVendorOrders = async (vendorId: string): Promise<ProductOrdersResponse> => {
  try {
    const response = await api.get(`/master-admin/getOrdersByVendor/${vendorId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching vendor orders:', error);
    throw error;
  }
}; 